<template></template>

<script>

import appConfig from "../../../config/app_config";
import { mapGetters } from "vuex";
export default {
  name: "BaseComponent",
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters({
      userType: "auth/userType",
      user: "auth/user",
      userName: "auth/userName",
      userLevel: "auth/userLevel",
      partnerId: "auth/partnerId",
      customerPreferences: "getCustomerPreferences",
      currentAccountId: "getCurrentAccountId",
      userGroupsForAccount: "getUserGroupsForAccount"
    })
  },
  watch: {
    currentAccountId: function(newVal, oldVal) {
      this.updateCurrentAccountId(newVal, oldVal);
    },
    partnerId: function(newVal, oldVal) {
      this.updatePartnerId(newVal, oldVal);
    },
    userLevel: function(newVal, oldVal) {
      this.updateAuthUserLevel(newVal, oldVal);
    },
    user: function(newVal, oldVal) {
      this.updateUser(newVal, oldVal);
    },
    userType: function(newVal, oldVal) {
      this.updateUserType(newVal, oldVal);
    },
    customerPreferences: {
      handler(data) {
        this.updateCustomerPreferences(data);
      },
      deep: true
    },
    userGroupsForAccount: {
      handler(data) {
        this.updateUserGroupsForAccount(data);
      },
      deep: true
    }
  },
  created() {
  },
  beforeDestroy() {
  },
  methods: {
    updateCurrentAccountId(newVal, oldVal = null) {
    },
    updatePartnerId(newVal, oldVal = null) {
    },
    updateAuthUserLevel(newVal, oldVal = null) {
    },
    updateCustomerPreferences(newVal) {
    },
    updateUserGroupsForAccount(newVal) {
    },
    updateUser(newVal) {
    },
    updateUserType(newVal) {
    }
  }
};
</script>

<style>
</style>
